import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class OrganPricelistModel extends BaseModel {

    constructor() {
        super({ 
                name: "organ_pricelist",
                tableName: 'organ_pricelist', 
                label: "Bảng giá cơ quan", 
                display_key: 'office_tpl_id', 
                default_order: { key: 'updated_at', direction: 'asc' } }, 
            {
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                display: false
            },
            office_tpl_ref: { 
                refs: 'office_tpl {id name code}',
                display: false
            },
            display_office_tpl_code: { 
                name: "display_office_tpl_code", 
                label: "Mã văn phòng",
                width: 6,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_office_tpl_code = '';
                    if(data.office_tpl !== undefined && data.office_tpl !== null){
                        data.display_office_tpl_code = data.office_tpl.code;
                    }
                }
            },
            display_office_tpl_name: { 
                name: "display_office_tpl_name", 
                label: "Tên văn phòng",
                width: 20,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_office_tpl_name = '';
                    if(data.office_tpl !== undefined && data.office_tpl !== null){
                        data.display_office_tpl_name = data.office_tpl.name;
                    }
                }
            },
            office_agency_ref: { 
                refs: 'office_agency {id name code}',
                display: false
            },
            display_office_agency_code: { 
                name: "display_office_agency_code", 
                label: "Mã cơ quan",
                width: 6,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_office_agency_code = '';
                    if(data.office_agency !== undefined && data.office_agency !== null){
                        data.display_office_agency_code = data.office_agency.code;
                    }
                }
            },
            display_office_agency_name: { 
                name: "display_office_agency_name", 
                label: "Tên cơ quan",
                width: 20,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_office_agency_name = '';
                    if(data.office_agency !== undefined && data.office_agency !== null){
                        data.display_office_agency_name = data.office_agency.name;
                    }
                }
            },
            configed: { 
                name: "configed", 
                label: "Cài đặt giá văn bản theo Quận/ Huyện",
                width: 8,
                class: "center",
                computed: (data) => {
                    console.log(data)
                    data.configed = '<div style="text-align: center;"><i class="pi pi-check"></i></div>';
                }
            },
        },)
    }

}